<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M57.5 30.5H10.12l15.44-15.44a1.5 1.5 0 00-2.12-2.12L5.79 30.59a2 2 0 000 2.82l17.65 17.65a1.5 1.5 0 002.12 0 1.49 1.49 0 000-2.12L10.12 33.5H57.5a1.5 1.5 0 000-3z"/></svg>